// extracted by mini-css-extract-plugin
module.exports = {"AreaPage__Preamble":"AreaPage_AreaPage__Preamble__d7seJ","AreaPage__Title":"AreaPage_AreaPage__Title__SO_dM"};